<template>
  <div class="">
    <span v-if="item.ikom != 0">
      {{ String(addCommas(item.ikom)).replace(",00", "") }}
    </span>
    <a class="bluelink" :href="item.website" target="_blank" v-else>{{
              item.ikom | toIndividual
            }}</a>
    <v-icon
      right
      small
      style="margin: 0"
      @click="() => getTarifNote(item)"
      v-if="role() !== roleObj.users"
      >info</v-icon
    >
    <br />
    <span class="procent" v-if="item.ikom != 0">{{
      procent(item.ikom, calc.summ, calc.days, yearProcent)
    }}</span>
  </div>
</template>
<script>
import { roleObj } from "@/plugins/roles";

export default {
  name: "",
  data: () => ({
    roleObj,
  }),
  props: {
    item: { type: Object },
    calc: { type: Object },
    yearProcent: { type: Boolean },
  },
  methods: {
    async getTarifNote(item) {
      const data = await this.$store.dispatch(
        "GET_TARIF_NOTE",
        item.product_id
      );
      this.$emit("dialog", { dialog: true, dialogText: data });
    },
  },
  filters: {
    toIndividual: function (value) {
      if (value == 0 || value == "0") return "индивидуально";
      return value;
    },
  },
};
</script>
<style lang="sass" scoped></style>
